var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "290" },
          model: {
            value: _vm.delDialog,
            callback: function($$v) {
              _vm.delDialog = $$v
            },
            expression: "delDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-text", [
                _vm._v("Are you sure you want to delete this category?")
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "elc-button-radius",
                      attrs: { flat: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.delDialog = false
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "elc-button-radius-color",
                      attrs: { flat: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.deleteCategory()
                        }
                      }
                    },
                    [_vm._v("OK")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", width: "300px" },
          on: {
            keydown: function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
              ) {
                return null
              }
              return _vm.cancelAddCategoryDialog($event)
            }
          },
          model: {
            value: _vm.addCategoryDialog,
            callback: function($$v) {
              _vm.addCategoryDialog = $$v
            },
            expression: "addCategoryDialog"
          }
        },
        [
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c("v-card", [
                _c(
                  "div",
                  [
                    _c(
                      "v-container",
                      { attrs: { "grid-list-md": "" } },
                      [
                        _c(
                          "div",
                          { staticStyle: { position: "relative" } },
                          [
                            !_vm.addEditFlag
                              ? _c("h2", { staticClass: "p-10" }, [
                                  _vm._v("Add Category ")
                                ])
                              : _c("h2", { staticClass: "p-10" }, [
                                  _vm._v("Update Category ")
                                ]),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              {
                                staticStyle: {
                                  position: "absolute",
                                  top: "0",
                                  right: "0"
                                },
                                attrs: { bottom: "" }
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { slot: "activator", icon: "" },
                                    on: { click: _vm.cancelAddCategoryDialog },
                                    slot: "activator"
                                  },
                                  [_c("v-icon", [_vm._v("clear")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Close")])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          { attrs: { wrap: "" } },
                          [
                            _c(
                              "v-flex",
                              { staticClass: "p-10", attrs: { xs12: "" } },
                              [
                                _vm.addCategoryDialog
                                  ? _c("v-text-field", {
                                      attrs: {
                                        rules: _vm.fieldRules,
                                        label: "Name*",
                                        autofocus: "",
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.category.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.category, "name", $$v)
                                        },
                                        expression: "category.name"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          {
                            staticClass: "p-10 text-sm-right",
                            attrs: { xs12: "" }
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "elc-button-radius",
                                on: { click: _vm.cancelAddCategoryDialog }
                              },
                              [_vm._v("Cancel")]
                            ),
                            _vm._v(" "),
                            !_vm.addEditFlag
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "elc-button-radius-color",
                                    attrs: {
                                      disabled:
                                        _vm.category.name === "" || !_vm.valid
                                    },
                                    on: { click: _vm.addCategory }
                                  },
                                  [_vm._v("Save\n                            ")]
                                )
                              : _c(
                                  "v-btn",
                                  {
                                    staticClass: "elc-button-radius-color",
                                    attrs: {
                                      disabled:
                                        _vm.category.name === "" || !_vm.valid
                                    },
                                    on: { click: _vm.updateCategory }
                                  },
                                  [
                                    _vm._v(
                                      "Update\n                            "
                                    )
                                  ]
                                )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { width: "550px", persistent: "" },
          on: {
            keydown: function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
              ) {
                return null
              }
              return _vm.cancelCategoryDialog($event)
            }
          },
          model: {
            value: _vm.categoryDialog,
            callback: function($$v) {
              _vm.categoryDialog = $$v
            },
            expression: "categoryDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "p-10" },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs4: "", md2: "" } }, [
                            _c("h2", { staticClass: "p-10" }, [
                              _vm._v("Category ")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "p-l-20",
                              attrs: { xs6: "", md9: "" }
                            },
                            [
                              _c(
                                "v-tooltip",
                                { attrs: { bottom: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "elc-button-rounded",
                                      attrs: {
                                        slot: "activator",
                                        fab: "",
                                        small: ""
                                      },
                                      on: { click: _vm.openAddCategoryDialog },
                                      slot: "activator"
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticStyle: { "margin-top": "-4px" },
                                          attrs: { dark: "" }
                                        },
                                        [_vm._v("add")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Add Category")])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "", md1: "" } },
                            [
                              _c(
                                "v-tooltip",
                                { attrs: { bottom: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { slot: "activator", icon: "" },
                                      on: { click: _vm.cancelCategoryDialog },
                                      slot: "activator"
                                    },
                                    [_c("v-icon", [_vm._v("clear")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Close")])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.loader
                    ? _c(
                        "v-flex",
                        {
                          staticClass: "p-8 text-xs-center",
                          attrs: { xs12: "" }
                        },
                        [
                          _vm.categoriesArr.length === 0
                            ? _c("span", [_vm._v(" No categories found")])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            _vm._l(_vm.categoriesArr, function(data) {
                              return _c(
                                "v-list-tile",
                                {
                                  key: data.id,
                                  staticClass: "elc-setting-cetegory-dialog"
                                },
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v(_vm._s(data.name))
                                      ])
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-action",
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { wrap: "" } },
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              staticClass: "m-10",
                                              attrs: {
                                                slot: "activator",
                                                bottom: ""
                                              },
                                              slot: "activator"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    slot: "activator",
                                                    small: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.openEditCategoryDialog(
                                                        data
                                                      )
                                                    }
                                                  },
                                                  slot: "activator"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            edit\n                                        "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [_vm._v("Edit")])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-tooltip",
                                            {
                                              staticClass: "m-10",
                                              attrs: {
                                                slot: "activator",
                                                bottom: ""
                                              },
                                              slot: "activator"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    slot: "activator",
                                                    disabled:
                                                      data.resourcesCount !== 0,
                                                    small: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.openDelDialog(data)
                                                    }
                                                  },
                                                  slot: "activator"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            delete\n                                        "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [_vm._v("Delete")])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            })
                          )
                        ],
                        1
                      )
                    : _c("v-flex", [
                        _c(
                          "div",
                          { staticClass: "p-10 text-xs-center" },
                          [
                            _c("v-progress-circular", {
                              attrs: { indeterminate: "", color: "primary" }
                            })
                          ],
                          1
                        )
                      ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "elc-card-main" },
        [
          _c(
            "v-layout",
            { staticClass: "elc-setting-card", attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", md3: "" } },
                [
                  _c(
                    "v-card",
                    {
                      staticStyle: { cursor: "pointer !important" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.openCategoryDialog($event)
                        }
                      }
                    },
                    [
                      _c("h3", { staticClass: "headline mb-0" }, [
                        _vm._v("Category")
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "", md3: "" } },
                [
                  _c(
                    "v-card",
                    {
                      staticStyle: { cursor: "pointer !important" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.goToKBFolder($event)
                        }
                      }
                    },
                    [
                      _c("h3", { staticClass: "headline mb-0" }, [
                        _vm._v("Knowledge Base Folder")
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("alert-modal", {
        attrs: { alertMsg: _vm.msg, alertMsgDialog: _vm.alertDialog },
        on: {
          closeAlert: function($event) {
            _vm.alertDialog = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58c7dd2f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58c7dd2f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings/Settings.vue
// module id = null
// module chunks = 